(function () {
    'use strict';

    angular.module("imApp").factory("consignmentShipmentService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1104,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1105,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1106,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
